import React from 'react';
import { styled } from '@mui/material/styles';
import { Container, Box } from "@mui/material";
import TopBar from "./TopBar";

const PREFIX = 'MainContainer';

const classes = {
    main: `${PREFIX}-main`
};

const StyledContainer = styled(Container)((
    {
        theme
    }
) => ({
    [`&.${classes.main}`]: {//notch :)
        paddingTop: `env(safe-area-inset-top)`,
        paddingLeft: `env(safe-area-inset-left)`,
        paddingRight: `env(safe-area-inset-right)`
    }
}));

const MainContainer = ({ children, menuItems, ...props}) => {


    const Bar = props.topbar || (props.topbar === false ? React.Fragment : TopBar);

    

    return (
        <StyledContainer maxWidth="md" className={classes.main}>
            <Bar menuItems={menuItems} {...props} />

            <Box>
                <main>{children}</main>
            </Box>
        </StyledContainer>
    );
}

export default MainContainer;